import * as React from 'react'
import { FaIcon, faCalculator, faArrowDownToLineSolid } from '@/lib/fa'
import { Button } from '@/ui/button'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

interface CalculateRecordsViewProps {
  onImportFile?: () => void
  onCalculateFromData?: () => void
}

const CalculateRecordsView: React.FC<CalculateRecordsViewProps> = ({
  onImportFile,
  onCalculateFromData,
}) => {
  const { t } = useLocalize()
  return (
    <div className="tw-flex tw-h-full tw-w-full tw-items-center tw-justify-center">
      <div className="tw-flex tw-w-full tw-max-w-4xl tw-flex-col tw-items-center tw-justify-center tw-gap-8 tw-rounded-2xl tw-bg-white tw-p-12 tw-text-center">
        {/* Icon */}
        <div className="tw-flex tw-h-20 tw-w-20 tw-items-center tw-justify-center tw-rounded-full tw-bg-[#fafbff]">
          <FaIcon
            icon={faCalculator}
            className="tw-h-10 tw-w-10 tw-text-content-base"
          />
        </div>

        {/* Text Content */}
        <div className="tw-flex tw-max-w-md tw-flex-col tw-items-center tw-gap-2">
          <h2 className="tw-text-[18px] tw-font-medium tw-text-[#1f2937]">
            {t('timesheet.calculate-timesheet')}
          </h2>
          <p className="tw-w-[235px] tw-text-center tw-text-sm tw-text-[#1f2937]">
            {t('timesheet.calculate-view-description')}
          </p>
        </div>

        {/* Actions */}
        <div className="tw-flex tw-flex-col tw-gap-4 sm:tw-flex-row">
          <Button
            size="sm"
            variant="secondary"
            onClick={onImportFile}
            faLeadingIcon={faArrowDownToLineSolid}
            className="!tw-h-10 !tw-w-[168px] !tw-rounded-lg"
          >
            {t('timesheet.import-from-file')}
          </Button>
          <Button
            size="sm"
            variant="primary"
            onClick={onCalculateFromData}
            faLeadingIcon={faCalculator}
            className="!tw-h-10 !tw-w-[165px] !tw-rounded-lg"
          >
            <span className="tw-text-nowrap tw-text-sm">{t('timesheet.calculate-from-data')}</span>
          </Button>
        </div>
      </div>
    </div>
  )
}

export default CalculateRecordsView
